import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Menu, MenuItem } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import "./LanguageSwitch.css";

const LanguageSwitch = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem('language', language); // Sačuvaj jezik u localStorage
    handleClose();
  };

  return (
    <div>
      <IconButton onClick={handleClick} className="languageSwitch">
        <LanguageIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleLanguageChange('en')} selected={i18n.language === 'en'}>English</MenuItem>
        <MenuItem onClick={() => handleLanguageChange('sr')} selected={i18n.language === 'sr'}>Srpski</MenuItem>
        <MenuItem onClick={() => handleLanguageChange('hu')} selected={i18n.language === 'hu'}>Magyar</MenuItem>
      </Menu>
    </div>
  );
};

export default LanguageSwitch;
